export default __webpack_public_path__ + "static/media/inr-depo-withdrawals.5508329f.svg";